import { render, staticRenderFns } from "./cancel-detail.vue?vue&type=template&id=36d5f406&scoped=true&"
import script from "./cancel-detail.vue?vue&type=script&lang=js&"
export * from "./cancel-detail.vue?vue&type=script&lang=js&"
import style0 from "./cancel-detail.vue?vue&type=style&index=0&id=36d5f406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5f406",
  null
  
)

export default component.exports